'use client';

import { useEffect, useState } from 'react';
import { isFontLoaded } from '@/lib/utils';

export default function FontLoader() {
  const [fontStatus, setFontStatus] = useState<{
    primary: boolean;
    fallback: boolean;
    body: boolean;
  }>({ primary: false, fallback: false, body: false });

  useEffect(() => {
    const checkFonts = async () => {
      try {
        // Check primary font
        const primaryLoaded = await isFontLoaded('1816 Printed Regular');
        
        // Check fallback font
        const fallbackLoaded = await isFontLoaded('Brother-1816-Regular');
        
        // Check body font
        const bodyLoaded = await isFontLoaded('Avenir Regular');
        
        setFontStatus({
          primary: primaryLoaded,
          fallback: fallbackLoaded,
          body: bodyLoaded
        });
        
        if (!primaryLoaded) {
          console.warn('1816 Printed Regular font not loaded. Check if the font file exists at /public/fonts/1816Printed-Regular.woff2');
        } else {
          console.log('1816 Printed Regular font loaded successfully!');
        }
        
        if (!fallbackLoaded) {
          console.warn('Brother-1816-Regular font not loaded. Check if the font file exists at /public/fonts/tipotype_-_brother-1816-bold-webfont.ttf');
        } else {
          console.log('Brother-1816-Regular font loaded successfully!');
        }
        
        if (!bodyLoaded) {
          console.warn('Avenir Regular font not loaded. Check if the font files exist at /public/fonts/Avenir-Regular.woff2 and /public/fonts/Avenir-Regular.woff');
        } else {
          console.log('Avenir Regular font loaded successfully!');
        }
      } catch (error) {
        console.error('Error checking font status:', error);
      }
    };

    checkFonts();
  }, []);

  // This component doesn't render anything visible
  return null;
} 